import styled from 'styled-components';

export const ThingsYouShouldKnowWrapper = styled.div(
  props => `
    background-color: ${props.theme.colors.yellow.lightYellow};
    align-items: center;
    padding: ${props.theme.spacing.large.l15};
    border-bottom-left-radius: ${props.theme.misc.borderRadius.base};
    border-bottom-right-radius: ${props.theme.misc.borderRadius.base};
    margin: 0;   
  `,
);

export const TitleOuterWrapper = styled.div(
  props => `
    display:flex; 
    align-items:center;
  `,
);

export const TitleWrap = styled.div(
  props => `
    display:flex;
    font-size:${props.theme.font.large.font16};
    color: ${props.theme.colors.black.base};
    font-weight:bold;
    font-family:${props.theme.font.fontFamily};
    margin-left: ${props.theme.spacing.base};

  `,
);

export const ThingsListItem = styled.ul(
  props => `
    list-style-type:disc;
    margin: ${props.theme.spacing.large.l15} 0 0 ${props.theme.spacing.large.l15} ;
> li{
    color:${props.theme.colors.red.base};
}

  `,
);
